module.exports = __webpack_public_path__ + "static/media/upload.66520388.svg";